import { dayjs } from 'lib/dayjs';
import { Message } from './Hooks/useLangflowChat';

export const buildChatMessage = ({
  content,
  sender,
  date,
}: {
  content: string;
  date?: string;
  sender?: Message['sender'];
}): Message => {
  return {
    id: crypto.randomUUID(),
    content,
    date: dayjs(date).toISOString(),
    sender: sender ?? 'User',
  };
};

export function formatChatTime(date: Date) {
  const dayjsDate = dayjs(date);
  const now = dayjs();

  const isToday = dayjsDate.isSame(now, 'day');

  if (isToday) {
    const diffMinutes = now.diff(dayjsDate, 'minute');
    if (diffMinutes === 0) return 'Just now';
    if (diffMinutes < 60) return `${diffMinutes}m ago`;

    const diffHours = now.diff(dayjsDate, 'hour');
    return `${diffHours}h ago`;
  }

  return dayjsDate.format('MMM D, YYYY');
}
